import { Group } from "@mantine/core"

import { CustomFieldItemCard } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldItemCard"
import { HorizontalDivider } from "~/pages/Brand/Products/Details/CustomFieldGraph/Divider.tsx"
import type { CustomFieldTreeBranchProps } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"

export const CustomFieldTreeBranch = ({
  item,
  hideFirstDivider = false,
  customFieldsDefs,
  operations,
  originCue,
}: CustomFieldTreeBranchProps) => {
  return (
    <Group key={item.id} gap={0} align="flex-start" wrap="nowrap">
      {!hideFirstDivider && <HorizontalDivider />}
      <CustomFieldItemCard
        customFieldsDefs={customFieldsDefs}
        itemReference={item.reference}
        operations={operations}
        originCue={originCue}
      />
    </Group>
  )
}
